import moment from 'moment';

import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import {
  Component,
  Input
} from '@angular/core';

import { JobsService }     from '../transaction-center/jobs/transaction-center.jobs.service';
import { MessagesService } from '../messages/messages.service';

import { DATE_FORMAT } from './booking-diary.layout';

// Turns a day's open bookings into job cards, from the day the diary is on or another picked here;
// a modal of its own only for the diary's look and preset day, as the start itself is JobsService's
@Component({
  selector   : 'wor-booking-diary-start-jobs-modal',
  template: require('./booking-diary.start-jobs-modal.component.html')
})
export class BookingDiaryStartJobsModalComponent {
  @Input() date : string;

  isStarting : boolean = false;

  constructor (
    public  activeModal      : NgbActiveModal,
    private jobsService      : JobsService,
    private messagesService  : MessagesService,
    private translateService : TranslateService
  ) {}

  get canStart () : boolean {
    return this.hasDate && !this.isStarting;
  }

  get dateLabel () : string {
    return this.hasDate
      ? moment(this.date, DATE_FORMAT).format('dddd, D MMMM YYYY')
      : this.translateService.instant('BOOKING_SPACE.DIARY.CHOOSE_DATE');
  }

  get hasDate () : boolean {
    return !!this.date && moment(this.date, DATE_FORMAT, true).isValid();
  }

  start () : void {
    if ( !this.canStart ) {
      return;
    }

    this.isStarting = true;

    this.jobsService.startJobsForDate(this.date)
      .then(() => this.activeModal.close(this.date))
      .catch(err => {
        this.isStarting = false;

        this.messagesService.error(err);
      });
  }
}
